export default __webpack_public_path__ + "static/media/Patch 3.f8a2839b.png";